import React from 'react'

export const SectionTwoThirdsRight = ({ className = '', label, children }) => (
  <div className={`${className} flex flex-column flex-row-ns justify-between ma0-ns mv4`}>
    <div className="w-33-ns f5-ns mono">{label}</div>
    <div className="w-66-ns mt3 mt0-ns">{children}</div>
  </div>
)
